import '../partials/content/reviews/reviews-external/reviews-external';
